import "../styles/Footer.css";
import { PiWhatsappLogo } from "react-icons/pi";
import { SiInstagram } from "react-icons/si";
import { SlLocationPin } from "react-icons/sl";
import { FaYoutube } from "react-icons/fa";

export default function Footer() {
  const phone = "919363966702";
  const message = "Hello! I want to know more about your products.";
  const whatsappLink = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;

  return (
    <footer className="footer">

      <div className="footer-container">

        {/* LEFT */}
        <div className="footer-left">
          <h3>Connect with us</h3>

          <div className="social-icons">
            <a href={whatsappLink} target="_blank" rel="noreferrer" className="whatsapp">
              <PiWhatsappLogo />
            </a>

            <a
              href="https://www.instagram.com/aiyla_sha_crafts"
              target="_blank"
              rel="noreferrer"
              className="instagram"
            >
              <SiInstagram />
            </a>

            <a
              href="https://www.youtube.com/@Aiyla_Sha_Crafts" // 🔁 replace with your channel
              target="_blank"
              rel="noreferrer"
              className="youtube"
            >
              <FaYoutube />
            </a>
          </div>

          <p className="footer-text">Chat with us on WhatsApp</p>
        </div>

        {/* RIGHT */}
        <div className="footer-right">
          <h2 className="brand">Aiyla_Sha_Crafts</h2>

          <p className="address">
            <SlLocationPin className="icon" />
            Aiylashacrafts, Perambur, <br />
            Chennai-600011<br />
            Aiylashacrafts@gmail.com
          </p>
        </div>

      </div>

      {/* BOTTOM */}
      <div className="footer-bottom">
        © 2026 AIYLA_SHA_CRAFTS. All rights reserved.
      </div>

    </footer>
  );
}